import { withPublicHOC } from '../../hoc';

const Contact = () => {
  return <h1>Contact</h1>;
};

export default withPublicHOC(Contact);
